import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {forwardRef} from "@angular/core";
import { AutocompleteComponent } from "./autocomplete.component";

export const AutocompleteAccessor: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteComponent),
  multi: true
};
